import { combineReducers } from 'redux';
import { AuthenticationReducer } from './authentication.reducer';
import { ErrorLogReducer } from './errorLog.Reducer';
import { ConfigurationsReducer } from './configuration.reducer';
import { LanguageReducer } from './languageReducer.reducer';

export const reducers = combineReducers({
    UserData: AuthenticationReducer,
    errorLog: ErrorLogReducer,
    configuration: ConfigurationsReducer,
    LanguageInfo: LanguageReducer,
});
